import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image'
import Menu from '../../atoms/menu/menu'
import './terms-content.scss'

const TermsContent = () => {
  const {
    bannerHeader: { childImageSharp: bannerHeader },
    bannerHeaderMobile: { childImageSharp: bannerHeaderMobile },
    bannerFooter: { childImageSharp: bannerFooter },
    bannerFooterMobile: { childImageSharp: bannerFooterMobile },
  } = useStaticQuery(graphql`
      {
          bannerHeader: file(name: { eq: "Banner-TyC" }) {
              childImageSharp {
                  gatsbyImageData(width: 1400)
              }
          }
          bannerHeaderMobile: file(name: { eq: "Banner-TyC-mobile" }) {
              childImageSharp {
                  gatsbyImageData(width: 1400)
              }
          }
          bannerFooter: file(name: { eq: "Banner-Pata" }) {
              childImageSharp {
                  gatsbyImageData(width: 1400)
              }
          }
          bannerFooterMobile: file(name: { eq: "Banner-Pata-Mobile" }) {
              childImageSharp {
                  gatsbyImageData(width: 960)
              }
          }
      }
  `)

  return (
    <>
      <Menu />
      <div className='f-terms'>
        <GatsbyImage
          className='f-banner-terms'
          image={withArtDirection(getImage(bannerHeader), [
            {
              media: '(max-width: 900px)',
              image: getImage(bannerHeaderMobile),
            },
          ])}
        />

        <ol className='f-terms-content'>
          <li>
            Para formar parte de esta actividad, las participantes deben estar
            registradas en <b> NosotrasOnline.com.co </b>, actualizar sus datos
            de registro e ingresar correctamente su usuario de Instagram.
          </li>
          <li>
            La marca Nosotras y Productos Familia S.A. validará que los datos
            completados en el formulario sean correctos antes de elegir las 2000
            embajadoras.
          </li>
          <li>
            La inscripción forma parte del proceso de selección, pero no asegura
            que las participantes sean elegidas
          </li>

          <li>
            <b> Les enviaremos 1 kit de Buenas Noches. </b> El kit puede contener: Nosotras Natural Buenas Noches,
            Nosotras Buenas Noches Rapisec, Nosotras Buenas Noches Algodón 100%, Nosotras Buenas Noches Máxima
            Protección y Nosotras Buenas Noches Extra Protección. En conteo individual (el contenido de cada kit puede
            variar según la usuaria).
          </li>
          <li>

            Habrán retos en los que las usuarias podrán ganar premios durante la actividad, los cuales se irán revelando
            en el transcurso de la misma, cada reto tendrá un tiempo limitado para realizarlo y para participar en ellos
            la usuaria <b>debe usar correctamente el hashtag de cada uno, etiquetar la marca @Nosotrascolombia y tener
            su perfil público.</b> Para conocer cada uno de los retos, sus respectivos tiempos y premios, debes ingresar
            a la sección retos de la interna de la actividad.


          </li>


          <li>
            El hecho de participar en los retos no excluye a la embajadora de ser elegida como embajadora ganadora al
            final de la actividad, todo lo contrario, la ayudará en la selección. Al final de la actividad, <b>la marca
            Nosotras se encarga de elegir a las Embajadoras que hayan cumplido con los 3 retos y los hayan compartido de
            la manera más creativa,</b> pero que además hayan hecho la mejor labor compartiendo los beneficios de las 5
            referencias de toallas (Nosotras Natural Buenas Noches, Nosotras Buenas Noches Rapisec, Nosotras Buenas
            Noches Algodón 100%, Nosotras Buenas Noches Máxima Protección y Nosotras Buenas Noches Extra Protección).
            Escoger a las 3 ganadoras en orden ascendente, en el puesto #1, la embajadora que haya realizado su mejor
            labor, y así sucesivamente. Para ser ganadoras, los datos suministrados por las usuarias tendrán que ser
            validados por la marca.
          </li>
          <li>
            Dentro de los 20 días hábiles siguientes a la designación
            de las Embajadoras, se procederá con el envío del kit a través de un
            servicio de mensajería. El kit se entregará en la dirección
            registrada en la página web de NosotrasOnline.co Se entenderá que
            fue recibido a conformidad con la firma de cualquier persona que
            resida en esta dirección (en caso de que la Embajadora resida en
            conjunto cerrado, la firma del portero certificará la entrega a
            conformidad). Si la primera vez no es recibido, se intentará su
            entrega en una segunda oportunidad. Si en esa ocasión no es posible
            la entrega, no se procederá a realizar más intentos, se entenderá
            que el kit fue rechazado y no se enviará nuevamente.
          </li>
          <li>
            Al final de cada reto, la marca Nosotras se encargará de elegir a
            las embajadoras que hayan cumplido los retos de la manera más
            creativa, cumpliendo con los hashtags establecidos para cada reto.
            Dentro de estas embajadoras elegidas, se hará un sorteo para escoger
            a la ganadora por cada reto.
          </li>
          <li>
            El kit de Embajadoras no es canjeable por ningún otro concepto o
            producto, ni es intercambiable por dinero.
          </li>
          <li>
            En caso de que la Embajadora no pueda recibir su kit, no tendrá
            derecho a reclamo ni a algún tipo de indemnización o compensación,
            ni siquiera parcialmente.
          </li>
          <li>
            La marca Nosotras elegirá y premiará con 1 iphone 12 a las tres
            Embajadoras, uno por ganadora, que no solo hayan cumplido los retos
            sino que hayan compartido en cuatro publicaciones los beneficios de
            las 5 referencias de toallas para todos sus seguidores en Instagram.
          </li>
          <li>
            La marca Nosotras tiene el derecho de anular o descalificar
            cualquier material que considere que no cumple con las reglas del
            concurso. Del mismo modo procederá con el material que no tenga
            relación con la mecánica de la actividad, que considere no apto o
            que atente contra los valores de la marca.
          </li>
          <li>
            Los premios de la actividad serán personales e intransferibles, y no
            son acumulables con otras promociones o dinámicas.
          </li>
          <li>
            Con el hecho de participar en la actividad, las ganadoras aceptan y
            autorizan que sus nombres e imágenes aparezcan en las publicaciones
            y demás material de divulgación con fines promocionales que los
            organizadores deseen hacer durante la actividad o una vez este
            finalice, sin que ello implique la obligación de remunerarlas o
            compensarlas. Asimismo, renuncian a cualquier reclamo por derechos
            de imagen. Estos datos no serán recogidos para fines distintos a los
            expresados ni se cederán datos a terceros.
          </li>
          <li>
            Productos Familia S.A. no se hace responsable por la veracidad de
            los datos que las participantes ingresen en el momento del registro.
          </li>
          <li>
            Al participar en la actividad las usuarias aceptan las condiciones
            establecidas en el reglamento, la página web y correo electrónico.
          </li>


          <li>
            Esta actividad tendrá vigencia hasta el 10 de noviembre a las 15:00
          </li>
          <li>
            Inicio de la convocatoria: 2 de noviembre. Cierre de la convocatoria: 16 de noviembre. Publicaremos a las
            ganadoras de la convocatoria el 19 de noviembre.
          </li>

          <li>
            <b>Reto 1: </b> Del 18 al 25 de noviembre - 1 semana.
          </li>
          <li>
            <b>Reto 2: </b> Del 26 de noviembre al 5 de diciembre (10 días).
          </li>
          <li>
            <b>Reto 3: </b> Del 6 al 13 de diciembre (1 semana).
          </li>

          <li>
            Inscripciones hasta el 16 de noviembre.
          </li>
          <li>
            Anunciaremos a las ganadoras de los retos de la siguiente manera: <b>Reto 1: </b> 30 noviembre, <b>Reto
            2: </b> 8 de diciembre, <b>Reto 3: </b> 16 de diciembre.
          </li>
          <li>
            Esta actividad es válida solo para usuarias que vivan en Colombia
          </li>

        </ol>

        <GatsbyImage
          className='f-banner-terms'
          image={withArtDirection(getImage(bannerFooter), [
            {
              media: '(max-width: 900px)',
              image: getImage(bannerFooterMobile),
            },
          ])}
        />
      </div>
    </>
  )
}

export default TermsContent
